export const storeManageListNewData = [
  {
    id: 'baseInfo',
    title: '',
    data: []
  }
];
